import * as React from "react";
import styles from "./CardContent.scss";

interface IProps {
    children?: React.ReactNode[] | React.ReactNode;
}

class CardContent extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={styles.cardContent}>
                {this.props.children}
            </div>
        );
    }
}

export default CardContent;


// WEBPACK FOOTER //
// ./src/Components/Common/Card/CardContent/CardContent.tsx